import React from "react";
import PropTypes from "prop-types";
import WebformAnalytics from "./WebformAnalytics";
import MobileAnalytics from "./MobileAnalytics";

const WebformManager = props => {
  const { i18n, t, containerWidth, defaultLang } = props;

  return (
    <>
      {containerWidth > 768 && (
        <WebformAnalytics
          t={t}
          i18n={i18n}
          kind="webform"
          defaultLang={defaultLang}
        />
      )}
      {containerWidth <= 768 && (
        <MobileAnalytics
          t={t}
          containerWidth={containerWidth}
          i18n={i18n}
          defaultLang={defaultLang}
        />
      )}
    </>
  );
};

WebformManager.propTypes = {
  t: PropTypes.func, //.isRequired,
  i18n: PropTypes.shape({}), //.isRequired,
  containerWidth: PropTypes.number //.isRequired
};

export default WebformManager;
